module.exports = __webpack_public_path__ + "static/media/pc_en.c849c951.png";